import React from 'react';
import { Routes, Route } from 'react-router-dom';
import PageError from '../Shared/PageError';
import Confirm from './Confirm';
import TwoFACheck from './TwoFACheck';
import CheckEmail from './CheckEmail';
import RequestPasswordReset from './RequestPasswordReset';
import { useCache } from '../../state/CachingContext';

const Recovery = (): JSX.Element => {
  const { getCache } = useCache();

  const email = getCache('email');

  return (
    <>
      {email ? (
        <>
          <Routes>
            <Route path='/Password' element={<Confirm recoveryMode='PW' />} />
            <Route path='/2FA' element={<Confirm recoveryMode='2FA' />} />
            <Route path='/Account' element={<Confirm recoveryMode='DEL' />} />
            <Route path='/NotVerified' element={<Confirm recoveryMode='NotVerified' />} />
            <Route path='/DeadEnd' element={<Confirm recoveryMode='NoRecovery' />} />
            <Route path='/Authenticate' element={<TwoFACheck />} />
            <Route path='/RequestPasswordReset' element={<RequestPasswordReset />} />
            <Route path='/CheckEmail' element={<CheckEmail />} />
          </Routes>
        </>
      ) : (
        <PageError code='500' message='noEmail' />
      )}
    </>
  );
};

export default Recovery;
